/* eslint-disable */

const DEFAULT_SMALL_POPUP_TIMEOUT = 3500;
const DEFAULT_SIMPLE_NOTIFICATION_TIMEOUT = 3500;
const DEFAULT_NOTIFICATION_CLOSE_TIMEOUT = 5000;
const DEFAULT_SUCCESS_SIDE_NOTIFICATION_CLOSE_TIMEOUT = 250;
const MARKET_OPEN = 'Open';
const MARKET_SUSPENDED = 'Suspended';
const MARKET_EXPIRED = 'Expired';
const MARKET_SETTLED = 'Settled';
const MARKET_CLOSED = 'Closed';
const MARKET_MAINTENANCE = 'Maintenance';
const SOCIAL_LOGIN_OR_REGISTER = 'login-register';
const SOCIAL_LOGIN_ADD = 'add';

// set to false to show 'setup 2FA' prompt on login and at end of registration flows
const DISABLE_TWO_FACTOR_PROMPT = (process.env.DISABLE_TWO_FACTOR_PROMPT !== null && process.env.DISABLE_TWO_FACTOR_PROMPT !== undefined) ? process.env.DISABLE_TWO_FACTOR_PROMPT : true;

const CARDS = {
  VISA: 'visa',
  AMERICAN_EXPRESS: 'americanexpress',
  DISCOVER: 'discover',
  MASTERCARD: 'mastercard',
  BLANK: 'blank',
};

function getDay(index) {
  const value = index + 1;
  return {
    label: (value < 10) ? `0${value.toString()}` : value.toString(),
    value,
  };
}

function getMonth(index) {
  const value = index + 1;
  return {
    label: (value < 10) ? `0${value.toString()}` : value.toString(),
    value,
  };
}

function getYear(index) {
  const year = (new Date()).getFullYear();
  const value = year - index;

  return {
    label: value.toString(),
    value,
  };
}

function getExpiryYear(index) {
  const year = (new Date()).getFullYear();
  const value = year + index;

  return {
    label: value.toString(),
    value,
  };
}

function getBirthYear(index) {
  const year = (new Date()).getFullYear() - 18;
  const value = year - index;

  return {
    label: value.toString(),
    value,
  };
}

const days = [...new Array(31)].map((el, index) => getDay(index));
const months = [...new Array(12)].map((el, index) => getMonth(index));
const years = [...new Array(100)].map((el, index) => getYear(index));
const expiryYears = [...new Array(13)].map((el, index) => getExpiryYear(index));
const birthYears = [...new Array(101)].map((el, index) => getBirthYear(index));

const statesCodeToNameMap = {
  "AL": "Alabama",
  "AK": "Alaska",
  "AS": "American Samoa",
  "AZ": "Arizona",
  "AR": "Arkansas",
  "CA": "California",
  "CO": "Colorado",
  "CT": "Connecticut",
  "DE": "Delaware",
  "DC": "District Of Columbia",
  "FM": "Federated States Of Micronesia",
  "FL": "Florida",
  "GA": "Georgia",
  "GU": "Guam",
  "HI": "Hawaii",
  "ID": "Idaho",
  "IL": "Illinois",
  "IN": "Indiana",
  "IA": "Iowa",
  "KS": "Kansas",
  "KY": "Kentucky",
  "LA": "Louisiana",
  "ME": "Maine",
  "MH": "Marshall Islands",
  "MD": "Maryland",
  "MA": "Massachusetts",
  "MI": "Michigan",
  "MN": "Minnesota",
  "MS": "Mississippi",
  "MO": "Missouri",
  "MT": "Montana",
  "NE": "Nebraska",
  "NV": "Nevada",
  "NH": "New Hampshire",
  "NJ": "New Jersey",
  "NM": "New Mexico",
  "NY": "New York",
  "NC": "North Carolina",
  "ND": "North Dakota",
  "MP": "Northern Mariana Islands",
  "OH": "Ohio",
  "OK": "Oklahoma",
  "OR": "Oregon",
  "PW": "Palau",
  "PA": "Pennsylvania",
  "PR": "Puerto Rico",
  "RI": "Rhode Island",
  "SC": "South Carolina",
  "SD": "South Dakota",
  "TN": "Tennessee",
  "TX": "Texas",
  "UT": "Utah",
  "VT": "Vermont",
  "VI": "Virgin Islands",
  "VA": "Virginia",
  "WA": "Washington",
  "WV": "West Virginia",
  "WI": "Wisconsin",
  "WY": "Wyoming",
};

const statesCodeToElectoralVotesMap  = {
  "NE03": 1,
  "NE02": 1,
  "NE01": 1,
  "NE-03": 1,
  "NE-02": 1,
  "NE-01": 1,
  "WA": 12,
  "DE": 3,
  "DC": 3,
  "WI": 10,
  "WV": 5,
  "HI": 4,
  "FL": 29,
  "WY": 3,
  "NH": 4,
  "NJ": 14,
  "NM": 5,
  "TX": 38,
  "LA": 8,
  "NC": 15,
  "ND": 3,
  "NE": 2, // 5
  "TN": 11,
  "NY": 29,
  "PA": 20,
  "CA": 55,
  "NV": 6,
  "VA": 13,
  "CO": 9,
  "AK": 3,
  "AL": 9,
  "AR": 6,
  "VT": 3,
  "IL": 20,
  "GA": 16,
  "IN": 11,
  "IA": 6,
  "OK": 7,
  "AZ": 11,
  "ID": 4,
  "CT": 7,
  "ME": 2, // 4
  "MD": 10,
  "MA": 11,
  "OH": 18,
  "UT": 6,
  "MO": 10,
  "MN": 10,
  "MI": 16,
  "RI": 4,
  "KS": 6,
  "MT": 3,
  "ME02": 1,
  "MS": 6,
  "ME01": 1,
  "ME-01": 1,
  "ME-02": 1,
  "SC": 9,
  "KY": 8,
  "OR": 7,
  "SD": 3
};

const SMALL_STATE_CODES = [
  'VT', 'NH', 'MA', 'RI', 'CT', 'NJ', 'DE', 'MD', 'DC',
];

export const STATIC_PAGES = {
  TERMS: 'TandC',
  RESEARCH: 'ResearchPage',
  PRIVACY: 'PrivacyPolicy',
  WHAT_IS: 'WhatIsPredictIt',
  HOW_TO_TRADE: 'HowToTradeOnPredictIt',
  PLATFORM_ANNOUNCEMENTS: 'PlatformAnnouncements',
  DEPOSIT_WARNING: 'DepositWarning',
  NEWS: 'News',
  NEWS_ARCHIVE: 'NewsArchive',
  RESPONSIBLE_TRADING: 'ResponsibleTrading',
};

export const FORM_TYPE_IDV = {
  INITIAL: 1,
  CHANGE_ADDRESS: 2,
  SSN4IDV: 3,
};

export const FORM_TYPE_TRIGGERS = {
  MODAL: 'modal',
  STANDALONE: 'standalone'
}

export default {
  FORM_TYPE_IDV,
  FORM_TYPE_TRIGGERS,
  CARDS,
  DEFAULT_SUCCESS_SIDE_NOTIFICATION_CLOSE_TIMEOUT,
  DEFAULT_NOTIFICATION_CLOSE_TIMEOUT,
  DEFAULT_SIMPLE_NOTIFICATION_TIMEOUT,
  DEFAULT_SMALL_POPUP_TIMEOUT,
  MARKET_OPEN,
  MARKET_SUSPENDED,
  MARKET_EXPIRED,
  MARKET_SETTLED,
  MARKET_CLOSED,
  MARKET_MAINTENANCE,
  DISABLE_TWO_FACTOR_PROMPT,
  SOCIAL_LOGIN_ADD,
  SOCIAL_LOGIN_OR_REGISTER,
  SMALL_STATE_CODES,
  birthYears,
  expiryYears,
  years,
  months,
  days,
  statesCodeToNameMap,
  statesCodeToElectoralVotesMap,
  STATIC_PAGES,
};



// WEBPACK FOOTER //
// ./src/constants.js